import { render, staticRenderFns } from "./KlarnaCheckoutOrderConfirmation.vue?vue&type=template&id=94a824f2&"
import script from "./KlarnaCheckoutOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./KlarnaCheckoutOrderConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports